"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconN7Z490 = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.897 3.217a.75.75 0 01.743.648l.007.102v9.996a.75.75 0 01-1.493.101l-.007-.101V3.967a.75.75 0 01.75-.75zm-5.039 12.278a.75.75 0 01.102 1.493l-.102.006H6.002a.75.75 0 01-.102-1.493l.102-.006h7.856z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.858 15.495a.75.75 0 01.102 1.493l-.102.006H6.002a.75.75 0 01-.102-1.493l.102-.006h7.856zm0 3.36a.75.75 0 01.102 1.493l-.102.007H6.002a.75.75 0 01-.102-1.493l.102-.007h7.856z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.858 18.855a.75.75 0 01.102 1.493l-.102.007H6.002a.75.75 0 01-.102-1.493l.102-.007h7.856zM7.874 11.03a.75.75 0 01.102 1.494l-.102.007h-5.09a.75.75 0 01-.103-1.493l.102-.007h5.091z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.757.455a.75.75 0 01.743.649l.007.101v10.576a.75.75 0 01-1.493.102l-.007-.102V1.205a.75.75 0 01.75-.75z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.58 0a1 1 0 011 1v22a1 1 0 01-1 1H2.4a1 1 0 01-1-1V1a1 1 0 011-1h19.18zm-.501 1.5H2.9v21h18.179v-21z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.965 3.133a1 1 0 011 1v7.393a1 1 0 01-1 1h-7.95a1 1 0 01-1-1V4.133a1 1 0 011-1h7.95zm-.5 1.499H8.514v6.393h6.951V4.632z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.402 5.552a1 1 0 011 1v2.555a1 1 0 01-1 1h-2.825a1 1 0 01-1-1V6.552a1 1 0 011-1h2.825zm-.5 1.5h-1.825v1.554h1.825V7.052z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconN7Z490, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;